import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { AuthService } from '@core/services/auth.service';
import { environment } from '@envs/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  const accessToken = authService.currentUser()?.token;
  const isApiUrl =
    req.url.startsWith(environment.mainApiUrl) ||
    req.url.startsWith(environment.messagingUrl) ||
    req.url.startsWith(environment.dispatchUrl) ||
    req.url.startsWith(environment.BIUrl);

  if (isApiUrl && accessToken) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`,
        'Accept-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
    });
  }
  return next(req);
};
